module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save_transplant_details":"Save Transplant Details"},"fr":{"save_transplant_details":"Sauvegarder les détails de transplantation"}}')
  delete Component.options._Ctor
}
